module.exports = __webpack_public_path__ + "img/wifi-off.a9675354.svg";